export const metersBetweenLatitudes = (lat1: number, lat2: number) => {
  //https://stackoverflow.com/questions/639695/how-to-convert-latitude-or-longitude-to-meters
  const latMid = (lat1 + lat2) / 2;
  const metersPerDegreeLat = 111132.954 - 559.822 * Math.cos(2.0 * latMid) + 1.175 * Math.cos(4.0 * latMid);
  //absolute value it so order of lats doesnt matter
  return Math.abs(metersPerDegreeLat * (lat1 - lat2));
};
